import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { IBusinessLoginRequest, IBusinessLoginResponse } from '../models/business-login.model';
import { IRegistrationLoginRequest, IRegistrationLoginSuccess } from '../models/registration-login.model';
//#region  Login returning user
export const loadLoginRequest = createAction('[Login] Load Login Request', props<{ request: IBusinessLoginRequest }>());
export const loadLoginSuccess = createAction('[Login] Load Login Success', props<{ response: IBusinessLoginResponse }>());
export const loadLoginFailure = createAction('[Login] Load Login Failure', props<{ error: IGenericError<ErrorResponse> }>());
export const clearLoginFailure = createAction('[Login] Clear Login Failure');
export const clearLoginSuccess = createAction('[Login] Clear Login Success');
//#endregion
